import { useSelector } from "react-redux";
import { selectMovieDetails } from "../features/movieSlice";
import { PlayIcon } from "@heroicons/react/solid";
import { RefreshIcon, BookmarkIcon } from "@heroicons/react/solid";

const Details = () => {
  const movie = useSelector(selectMovieDetails);

  const truncate = (string, n) => {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  };

  return (
    <div className="bg-gray-900 sm:h-screen w-full">
      <div className="lg:w-[80%] sm:ml-auto sm:mr-auto border-2 border-gray-900 shadow-2xl">
        <div className="sm:flex">
          <div className="">
            <div className="border border-gray-800 shadow-2xl">
              <img
                src={movie.poster_path}
                alt=""
                className="object-contain h-[600px] lg:h-[99vh]"
              />
            </div>
          </div>
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 flex-1">
            <div className="lg:ml-14">
              <div className="h-screen lg:h-0 p-3">
                <div className="hidden sm:block">
                  <h1 className="hidden sm:block text-gray-300 text-3xl tracking-wide lg:text-6xl sm:font-extrabold">
                    {movie.title}
                  </h1>
                </div>
                <div className="mt-3">
                  <h1 className="text-lg sm:text-xl font-bold text-gray-400">
                    Rating: {movie.vote_average}
                  </h1>
                </div>
                <div className="mt-4">
                  {movie.media_type && (
                    <p className="text-lg sm:text-xl font-bold text-gray-400">
                      Genre: {movie.media_type}
                    </p>
                  )}
                </div>
                <div>
                  {movie.release_date && (
                    <h1 className="text-lg font-bold mt-3 text-gray-400 sm:text-xl">
                      Released year: <span>{movie.release_date}</span>{" "}
                    </h1>
                  )}
                </div>
                <div className="flex justify-start mt-5">
                  <h1 className=" text-base text-gray-400 sm:text-xl">
                    {truncate(movie.overview, 250)}
                  </h1>
                </div>

                <div className="lg:flex lg:items-center mt-7">
                  <div className="flex items-center space-x-2 lg:mr-3 border shadow-2xl rounded-md border-gray-700 cursor-pointer p-2 bg-gray-400 mb-2 hover:bg-gray-300">
                    <PlayIcon className="h-10 text-gray-800 hover:text-green-400" />
                    <p className="text-gray-800 text-base font-bold lg:pr-5">
                      play
                    </p>
                  </div>

                  <div className="flex items-center space-x-2 border shadow-2xl lg:mr-3 rounded-md border-gray-700 cursor-pointer p-2 bg-gray-800 mb-2 hover:bg-gray-900">
                    <RefreshIcon className="h-10 text-gray-400" />
                    <p className="text-gray-400 text-base font-bold lg:pr-3">
                      Startover
                    </p>
                  </div>

                  <div className="flex items-center space-x-2 border shadow-2xl lg:mr-3 rounded-md border-gray-700 cursor-pointer p-2 bg-gray-800 mb-2 hover:bg-gray-900">
                    <BookmarkIcon className="h-10 text-gray-400" />
                    <p className="text-gray-400 text-base font-bold lg:pr-3">
                      Watch later
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
